import React, { ReactNode } from "react"

import { Container } from "@/ui/container"
import { Prose } from "@/ui/prose"
import { Layout } from "@/views/_layout"

export default function DocLayout(props: { children: ReactNode }) {
  return (
    <Layout>
      <Container css={{ py: "$8" }} size="md">
        <Prose color="muted">{props.children}</Prose>
      </Container>
    </Layout>
  )
}
